import { PesadosBrasilStorage } from './../../../services/pesados-brasil/pesados-brasil.storage';
import { CustomModalService } from '../../../shared/modais/custom-modal/custom-modal.service';
import { appSettings } from './../../../../environments/app.setings';
import { Originador } from './../../../services/pesados-brasil/originador.interface';
import { EnderecoCep } from './../../../services/cep/endereco-cep';
import { AgenteEndereco } from '../../../services/pesados-brasil/agente-endereco.interface';
import { finalize, take, takeWhile } from 'rxjs/operators';
import { AgenteService } from './../../../services/pesados-brasil/agente.service';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormArray,
  FormBuilder,
  FormGroup,
  NgForm,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  Renderer2,
  DoCheck,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ComprovanteRendaService } from '../../../services/comprovante-renda/comprovante-renda.service';
import { TipoVeiculoEnum } from '../../../produtos/shared/enums/tipo-veiculo.enum';
import { Data } from '../../../shared/partner/data';
import { FichaService } from '../../ficha-veiculo.service';
import { setFichaContent } from '../helpers/salvarFicha';
import { Avalista } from '../model/avalista';
import { Conjuge } from '../model/conjuge';
import { RecuperaAvalista } from '../model/recupera/recupera-avalista';
import { RecuperaCliente } from '../model/recupera/recupera-cliente';
import { TipoComprovanteRenda } from '../model/tipo-comprovante-renda';
import { VeiculoEmSeuNome } from '../model/veiculo';
import { LoginStorage } from './../../../login/login.storage';
import { MultipleSelectOptionData } from './../../../shared/components/multiple-select/multiple-select.interface';
import { ModalComponent } from './../../../shared/modais/modal/modal.component';
import { FichaCadastro } from './../ficha-cadastro';

import { ModalEncontrarCepComponent } from './../../../shared/endereco/modal-encontrar-cep/modal-encontrar-cep.component';
import { CepService } from './../../../services/cep/cep.service';
import { TelefoneCliente } from '../model/telefone-cliente';
import { onlyDigits } from '../../../shared/helper/utils';

@Component({
  selector: 'app-ficha-cadastro-cliente',
  templateUrl: './ficha-cadastro-cliente.component.html',
  styleUrls: ['./ficha-cadastro-cliente.component.scss'],
})
export class FichaCadastroClienteComponent implements OnInit, OnDestroy, DoCheck
{
  public TIPO_SOLIC_CLIENTE = 'CLIENTE';
  public TIPO_SOLIC_OUTRA = 'OUTRA';
  public TIPO_COMPROVANTE_RENDA_OUTRO = '40';

  @Input() fichaCadastro: FichaCadastro;

  showButtonRecuperaFicha: boolean = false;
  avalistaCpf: string;
  avalistaDataNascimento: string;
  avalistaCelular: string;
  avalistaRendaComprovada: string;
  avalistaRelac: string;
  isSelectedRelacAvalista = false;
  idLojista: number;

  isAvalista = false;
  isConjuge = false;

  subsValidarClienteCpf: Subscription;
  isValidatingClienteCpf = false;
  isValidatingAvalistaCpf = false;
  cadastroAntigoContent;
  dataRange = {
    min: 18,
    max: 85,
    message: 'A idade deve ser entre 18 e 85 anos',
  };

  listaTipoComprovanteRenda: TipoComprovanteRenda[] = [];
  multipleSelectData: MultipleSelectOptionData[] = [];
  showOutroComprovanteRenda = false;
  tipoComprovanteRendaTouched = false;
  outroComprovanteRendaTouched = false;
  loadingComprovanteRenda = false;
  comprovanteRendaOptions: any;
  formConjugeValid: boolean = false;
  hasAvalistaConjuge: boolean;

  public cepAgente: string = '';
  public isBuscandoCep = false;
  public agenteEndereco: AgenteEndereco;
  public cepPesquisado = false;
  public isAgentePesadosBr = false;
  public cepErrorStatus: any;
  public endereco: any = {};
  public originador: Originador;
  public cepErroMessage: string;

  @ViewChild('formCliente', { static: false }) ngForm: NgForm;
  private setted: boolean = false;
  public errorMessage: string = null;

  constructor(
    private readonly fichaService: FichaService,
    private readonly comprovanteRendaService: ComprovanteRendaService,
    private readonly router: Router,
    private readonly loginStorage: LoginStorage,
    private readonly fb: FormBuilder,
    private readonly agenteService: AgenteService,
    private readonly cepService: CepService,
    private readonly modalService: CustomModalService,
    private readonly pesadosBrasilStorage: PesadosBrasilStorage,
    private readonly renderer: Renderer2
  ) {}

  @ViewChild('modal', { static: true }) modal: ModalComponent;

  @ViewChild('dataNascimento', { static: true }) dataNascimento: ElementRef;

  formularioAvalista: FormArray = new FormArray([]);

  ngOnInit() {
    this.fichaCadastro.avalistaParentesco = '';
    this.initTipoComprovanteRenda();
    this.inicializacaoPesadosBrasil();
  }

  ngDoCheck(): void {
    if (
      this.ngForm &&
      this.ngForm.controls['celular-cliente'] &&
      !this.setted
    ) {
      this.ngForm.controls['celular-cliente'].setAsyncValidators([
        this.validCelphone(),
      ]);
      this.setted = true;
    }
  }

  private inicializacaoPesadosBrasil() {
    this.originador = this.loginStorage.originator;
    if (this.originador) {
      this.isAgentePesadosBr = this.originador.originador;
      if (
        Object.keys(this.pesadosBrasilStorage.agenteEndereco).length > 0 &&
        Object.keys(this.pesadosBrasilStorage.enderecoTotal.enderecos).length >
          0
      ) {
        this.agenteEndereco = this.pesadosBrasilStorage.agenteEndereco;
        this.handleFindEnderecoCep(
          this.pesadosBrasilStorage.enderecoTotal.enderecos[0]
        );
        this.cepAgente = this.endereco.cep;
        this.onCepExit();
      } else {
        this.pesadosBrasilStorage.clear();
      }
    }
  }

  ngOnDestroy() {
    if (this.subsValidarClienteCpf) {
      this.subsValidarClienteCpf.unsubscribe();
    }
  }

  initTipoComprovanteRenda() {
    this.loadingComprovanteRenda = true;
    this.comprovanteRendaService
      .getListaTipoComprovanteRenda()
      .pipe(finalize(() => (this.loadingComprovanteRenda = false)))
      .subscribe((res) => {
        this.listaTipoComprovanteRenda = res;

        this.listaTipoComprovanteRenda.forEach((item) => {
          this.multipleSelectData.push({
            id: item.chaveParametro,
            text: item.valorParametro,
          });
        });
      });

    this.comprovanteRendaOptions = {
      multiple: true,
    };
  }

  onClickAvalista() {
    this.isAvalista = !this.isAvalista;
    this.fichaCadastro.setAvalista(this.isAvalista);
  }

  onClickPrevious() {
    this.fichaCadastro.onClickPrevious();
  }

  checkResponseModal(event) {
    if (event) {
      this.fichaCadastro.setCliente(this.cadastroAntigoContent.clientes[0]);
      this.isValidatingClienteCpf = false;
    }
  }
  getCpfCliente() {
    if (this.fichaCadastro._client.cpf) {
      this.isValidatingClienteCpf = true;
      this.idLojista = this.fichaCadastro.IDLojista;
      if (
        this.fichaCadastro.solicitanteTipo === this.TIPO_SOLIC_CLIENTE ||
        this.fichaCadastro.solicitanteTipo === this.TIPO_SOLIC_OUTRA
      ) {
        this.idLojista = this.loginStorage.agente.lojaBalcaoId;
        if (!this.idLojista) {
          this.idLojista = this.loginStorage.agente.id;
        }
      }
      this.fichaService
        .recuperarDadosFicha(
          this.formatCpf(this.fichaCadastro._client.cpf),
          this.idLojista
        )
        .subscribe(
          (res) => {
            this.isValidatingClienteCpf = false;
            this.cadastroAntigoContent = res;
            if (
              this.cadastroAntigoContent.id &&
              this.cadastroAntigoContent.simulacao
            ) {
              this.showButtonRecuperaFicha = true;
            }
            this.modal.show();
          },
          (err) => {
            this.isValidatingClienteCpf = false;
          },
          () => {
            this.isValidatingClienteCpf = false;
          }
        );
    }
  }

  recuperarFicha() {
    this.modal.hide();
    this.getFicha(this.cadastroAntigoContent);
  }
  recuperarDados() {
    this.setDadosInFichaCadastro(this.cadastroAntigoContent);
    this.renderer.selectRootElement(this.dataNascimento.nativeElement).focus();
    this.modal.hide();
  }

  iniciarNovaFicha() {
    this.modal.hide();
  }

  onClickNext() {
    this.fichaCadastro.setPayload(
      'cpf',
      this.formatCpf(this.fichaCadastro._client.cpf)
    );
    this.fichaCadastro.setPayload(
      'dataNascimento',
      this.formatDateMiliseconds(this.fichaCadastro._client.dataNascimento)
    );
    this.fichaCadastro.setPayload(
      'ddd',
      this.fichaCadastro._client.telefones.celular.substring(0, 2)
    );
    this.fichaCadastro.setPayload(
      'celular',
      this.fichaCadastro._client.telefones.celular.substring(2)
    );
    this.fichaCadastro.setPayload('renda', this.fichaCadastro._client.renda);

    if (this.isPesados && !this.fichaCadastro._client.rendaFutura) {
      const comprovanteRenda =
        this.fichaCadastro._client.tipoComprovanteRenda.map(
          (itemTipoComprovante: any) => {
            if (itemTipoComprovante === this.TIPO_COMPROVANTE_RENDA_OUTRO) {
              return {
                tipoComprovante: itemTipoComprovante,
                textoOutroComprovante:
                  this.fichaCadastro._client.outroComprovanteRenda,
              };
            }
            return { tipoComprovante: itemTipoComprovante };
          }
        );

      this.fichaCadastro.setPayload('comprovanteRenda', comprovanteRenda);
    }

    if (this.isAvalista) {
      const avalistas = this.formularioAvalista.value.map((formulario) => {
        return {
          cpf: this.formatCpf(formulario.cpf),
          dataNascimento: this.formatDateMiliseconds(formulario.dataNascimento),
          ddd: formulario.celular.substring(0, 2),
          celular: formulario.celular.substring(2),
          renda: formulario.renda,
          grauParentesco: formulario.grauParentesco,
          veiculoProprio: formulario.veiculoEmSeuNome.isVeiculoEmMeuNome
            ? [this.mapVeiculo(formulario.veiculoEmSeuNome)]
            : undefined,
        };
      });

      this.fichaCadastro.setPayload('avalistas', avalistas);
      const a: Avalista[] = [];
      avalistas.forEach((element) => {
        const avalista = new Avalista();
        avalista.cpf = element.cpf;
        avalista.dataNascimento = element.dataNascimento;
        avalista.grauParentescoCliente = element.grauParentesco;
        avalista.renda = element.renda;
        avalista.veiculoEmSeuNome = element.veiculoProprio;
        const b = new TelefoneCliente([
          {
            categoria: { id: 3 },
            ddd: element.ddd,
            telefone: element.celular,
          },
        ]);
        avalista.telefones = new TelefoneCliente([
          {
            categoria: { id: 3 },
            ddd: element.ddd,
            telefone: element.celular,
          },
        ]);
        a.push(avalista);
      });
      this.fichaCadastro._avalistas.push(...a);
    }

    if (this.hasAvalistaConjuge) {
      let avalistaConjuge;
      this.formularioAvalista.value.forEach((formulario) => {
        if (formulario.grauParentesco === '1') {
          avalistaConjuge = {
            nomeConjuge: formulario.nomeConjuge,
            cpfConjuge: this.formatCpf(formulario.cpf),
            dataNascimentoConjuge: this.formatDateMiliseconds(
              formulario.dataNascimento
            ),
            telefoneConjuge: formulario.celular,
            classeProfConjuge: formulario.classeProfConjuge,
            cargoConjuge: formulario.cargoConjuge,
          };
        }
      });

      this.fichaCadastro.setPayload('conjuge', avalistaConjuge);
    }

    if (this.fichaCadastro.isConjuge) {
      this.fichaCadastro.conjuge.dataNascimentoConjuge =
        this.formatDateMiliseconds(
          this.fichaCadastro.conjuge.dataNascimentoConjuge
        );
      this.fichaCadastro.setPayload('conjuge', this.fichaCadastro.conjuge);
    }

    this.fichaCadastro.setPayload(
      'rendaFuturaEstimada',
      this.fichaCadastro._client.rendaFutura ? 'S' : 'N'
    );

    this.fichaCadastro.onClickNext();

    setFichaContent(this.fichaCadastro);

    this.putDataClient();
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }

  formatCpf(data) {
    if (data) {
      return data.replace(/[\.\-]/g, '');
    }
  }

  validateNextButton(formCliente, formConjuge) {
    const formAvalista = this.formularioAvalista.valid;
    const hasAvalistaMesmoCpf = this.formularioAvalista.value.some(
      (avalista: Avalista) => 
        avalista.cpf &&
        avalista.cpf === this.fichaCadastro._client.cpf
    );
    const hasVerificicaAvalista =
      this.isAvalista &&
      formAvalista &&
      this.formularioAvalista.value.every(
        (avalista: any) =>
          avalista.cpf !== this.fichaCadastro._client.cpf &&
          this.fichaCadastro._client.telefones &&
          avalista.celular !== this.fichaCadastro._client.telefones.celular &&
          (!avalista.veiculoEmSeuNome.isVeiculoEmMeuNome ||
            (avalista.veiculoEmSeuNome.isVeiculoEmMeuNome &&
              ((avalista.veiculoEmSeuNome.veiculoPlaca &&
                !avalista.veiculoEmSeuNome.isNaoSeiPlaca) ||
                (avalista.veiculoEmSeuNome.isNaoSeiPlaca &&
                  avalista.veiculoEmSeuNome.veiculoCategoria &&
                  avalista.veiculoEmSeuNome.veiculoMarca &&
                  avalista.veiculoEmSeuNome.veiculoAno &&
                  avalista.veiculoEmSeuNome.veiculoModelo &&
                  avalista.veiculoEmSeuNome.veiculoVersao))))
      );

    if (
      (formCliente && !this.isAvalista && !this.fichaCadastro.isConjuge) ||
      (formCliente && hasVerificicaAvalista && !this.fichaCadastro.isConjuge) ||
      (formCliente && formConjuge && !this.isAvalista) ||
      (formCliente && hasVerificicaAvalista && formConjuge) ||
      hasAvalistaMesmoCpf
    ) {
      if (this.isAgentePesadosBr && !this.agenteEndereco) {
        return true;
      }
      return false;
    }
    return true;
  }

  formatDateMiliseconds(data) {
    return Data.toMilissegundos(data);
  }

  onChangeRelacAvalista(event) {
    this.isSelectedRelacAvalista = event.target.selectedIndex !== 0;
  }

  setDadosInFichaCadastro(data) {
    this.fichaCadastro._client = new RecuperaCliente(data.clientes[0]).$client;
    this.ngForm.controls['celular-cliente'].updateValueAndValidity();

    if (data.avalista && this.fichaCadastro.setDadosAvalistas.every((i) => i)) {
      data.avalista.forEach((avalista) => {
        const avalistaRecurado = new RecuperaAvalista(avalista).$avalista;
        this.fichaCadastro._avalistas.push(avalistaRecurado);
        const oldAvalista = this.fb.group({
          cpf: ['', [Validators.required]],
          dataNascimento: ['', [Validators.required]],
          celular: ['', [Validators.required]],
          renda: ['', [Validators.required]],
          grauParentesco: ['', [Validators.required]],
          veiculoEmSeuNome: this.fb.group({
            isVeiculoEmMeuNome: [false],
            veiculoPlaca: [''],
            isNaoSeiPlaca: [false],
            veiculoCategoria: [null],
            veiculoMarca: [null],
            veiculoAno: [null],
            veiculoModelo: [null],
            veiculoVersao: [null],
          }),
        });
        this.setFormGroupValuesFromObject(oldAvalista, avalistaRecurado);
        this.formularioAvalista.push(oldAvalista);
      });
    }
  }

  getFicha(data) {
    this.router.navigate([`/resultadoparcial/${data.id}`]);
  }

  onChangeAvalistaConjuge(event) {
    this.hasAvalistaConjuge = event;

    if (this.hasAvalistaConjuge && this.isConjuge) {
      this.onClickConjuge();
    }
  }

  onClickConjuge() {
    this.isConjuge = !this.isConjuge;
    this.fichaCadastro.setConjuge(this.isConjuge);
  }

  onChangeTipoComprovanteRenda(data) {
    this.fichaCadastro._client.tipoComprovanteRenda = [];
    this.tipoComprovanteRendaTouched = true;

    this.listaTipoComprovanteRenda.forEach((item) => {
      if (data.includes(item.chaveParametro)) {
        this.fichaCadastro._client.tipoComprovanteRenda.push(item);
      }
    });

    this.showOutroComprovanteRenda =
      this.fichaCadastro._client.tipoComprovanteRenda.some(
        (item) => item.habilita === 'S'
      );
  }

  onBlurOutroComprovanteRenda() {
    if (
      this.fichaCadastro._client.outroComprovanteRenda === null &&
      this.showOutroComprovanteRenda
    ) {
      this.outroComprovanteRendaTouched = true;
    }
  }

  onChangeFormConjuge(formConjuge: Conjuge) {
    this.fichaCadastro.conjuge = formConjuge;
  }

  get tipoComprovanteRendaValid() {
    if (this.fichaCadastro._client.tipoComprovanteRenda) {
      return (
        this.fichaCadastro._client.tipoComprovanteRenda.length > 0 &&
        this.tipoComprovanteRendaTouched
      );
    }
  }

  private mapVeiculo(veiculo: VeiculoEmSeuNome): any {
    const {
      isVeiculoEmMeuNome,
      isNaoSeiPlaca,
      veiculoPlaca,
      veiculoCategoria,
      veiculoMarca,
      veiculoAno,
      veiculoModelo,
      veiculoVersao,
    } = veiculo;

    if (!isVeiculoEmMeuNome) {
      return {};
    }

    if (!isNaoSeiPlaca) {
      return {
        placa: veiculoPlaca,
      };
    }

    return {
      anoModelo: veiculoAno,
      categoria: { id: veiculoCategoria },
      marca: { id: veiculoMarca },
      modelo: { id: veiculoModelo },
      versao: { id: veiculoVersao },
      fipe: veiculoVersao ? veiculoVersao.codigoMolicar : undefined,
      placa: veiculoPlaca,
    };
  }

  get isPesados() {
    return this.fichaCadastro.tipoVeiculo === TipoVeiculoEnum.PESADOS;
  }

  getCEPAgente() {
    if (this.cepAgente) {
      this.isBuscandoCep = true;
      this.agenteEndereco = null;
      this.agenteService
        .getEnderecoAgentePorCep(
          this.cepAgente.replace('-', ''),
          this.originador.typesOrigination[0].code
        )
        .pipe(
          finalize(() => (this.isBuscandoCep = false)),
          take(1)
        )
        .subscribe(
          (res) => {
            this.agenteEndereco = res;
            this.pesadosBrasilStorage.registerAgenteEndereco(res);
          },
          (error) => {
            this.cepErrorStatus = error.status;
          }
        );
    }
  }

  onCepExit() {
    if (this.cepAgente) {
      this.isBuscandoCep = true;
      this.cepService
        .getEnderecoByCep(this.cepAgente.replace('-', ''))
        .pipe(
          finalize(() => (this.isBuscandoCep = false)),
          take(1)
        )
        .subscribe(
          (res) => {
            this.pesadosBrasilStorage.registerEnderecoTotal(res);
            this.handleFindEnderecoCep(res.enderecos[0]);
            this.getCEPAgente();
            this.cepErroMessage = undefined;
            return;
          },
          (err) => {
            this.cepErroMessage =
              err.error && err.error.message ? err.error.message : '';
            this.endereco = {};
            this.agenteEndereco = undefined;
          }
        );
    }
    this.cepErrorStatus = null;
  }

  private handleFindEnderecoCep(res) {
    this.endereco = {};

    if (res.logradouro) {
      this.endereco.endereco = res.logradouro;
    }

    if (res.uf) {
      this.endereco.uf = res.uf;
    }

    if (res.cidade) {
      this.endereco.cidade = res.cidade;
    }

    if (res.bairro) {
      this.endereco.bairro = res.bairro;
    }

    if (res.numero) {
      this.endereco.numero = res.numero;
    }

    if (res.cep) {
      this.endereco.cep = res.cep;
    }
  }

  onClickFindCep() {
    const initialState = {};
    const modal = this.modalService.show(ModalEncontrarCepComponent, {
      ...appSettings.MODAL_PARAMS,
      initialState,
    });

    const modalEncontrarCep = <ModalEncontrarCepComponent>modal.content;

    modalEncontrarCep.closeModal
      .pipe(takeWhile(() => modalEncontrarCep.alive))
      .subscribe((res) => {
        if (res) {
          const endereco = new EnderecoCep(res);
          this.handleFindEnderecoCep(endereco);
          this.cepAgente = endereco.cep;
          this.getCEPAgente();
        }
      });
  }

  getDddAndCelular(value): { ddd: string; telefone: string } {
    if (!value || value === '') return { ddd: '', telefone: '' };
    const digits = onlyDigits(value);
    const ddd = digits.substring(0, 2);
    const telefone = digits.substring(2);
    return { ddd, telefone };
  }

  validCelphone(): AsyncValidatorFn {
    this.errorMessage = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      if (!control.value || control.value.length === 0) {
        return Promise.resolve(null);
      }
      const dddCelular = this.getDddAndCelular(control.value);
      return this.fichaService
        .verifyCellPhone(dddCelular.ddd, dddCelular.telefone)
        .pipe(take(1))
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this.errorMessage = null;
            return null;
          }
          this.errorMessage = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }

  clearErrorMessage() {
    this.errorMessage = null;
  }

  private setFormGroupValuesFromObject(formGroup: FormGroup, source: any): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (this.isNestedFormGroup(control, source[key])) {
        this.setFormGroupValuesFromObject(control as FormGroup, source[key]);
        return;
      }
      if (control && source.hasOwnProperty(key)) {
        control.setValue(source[key]);
        control.updateValueAndValidity({ emitEvent: true });
      }
    });
    formGroup.updateValueAndValidity({ emitEvent: true });
  }

  private isNestedFormGroup(control: any, value: any): boolean {
    return control instanceof FormGroup && value && typeof value === 'object';
  }
}
